import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { DxTooltipComponent } from 'devextreme-angular';

@Component({
    selector: 'm4u-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss']
})
export class TagComponent {
    @Input() Size: 'small' | 'large' = 'small';
    @Input() Icon: string;
    @Input() Text: string;
    @Input() Hint: string;
    @Input() Visible: boolean;
    @Input() Color: string = '#0098fa';
    @Output() OnClick: EventEmitter<any> = new EventEmitter;
    
    constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    }

    ngOnInit() {
        this.SetElementStyles();
    }

    SetElementStyles() {
        const largeTagHeight = '36px';
        const smallTagHeight = '28px';
        const height = this.Size === 'small' ? smallTagHeight : largeTagHeight;
        this.renderer.setProperty(this.elementRef.nativeElement, 'style', `--tag-color: ${this.Color}; --tag-height: ${height}`);
    }

    Click(e) {
        this.OnClick.emit(e);
    }
}
